import React from 'react'

const SvgReset = props => (
    <svg viewBox="-477 479 44 44" {...props}>
        <path d="M-455 479c-12.2 0-22 9.8-22 22s9.8 22 22 22 22-9.8 22-22-9.9-22-22-22zm0 34c-1.1 0-2-.9-2-2s.9-2 2-2c4.4 0 8-3.6 8-8s-3.6-8-8-8-8 3.6-8 8c0 .3 0 .7.1 1h3.9l-6 6-6-6h4.1c0-.3-.1-.7-.1-1 0-6.6 5.4-12 12-12s12 5.4 12 12-5.4 12-12 12z" />
    </svg>
)

export default SvgReset



// WEBPACK FOOTER //
// ./src/ui/icons/Reset.js